import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { useDispatch } from "react-redux";

import { setUser, clearUser, logoutUser } from "@/auth/authSlice";
import { firebase } from "@/auth/firebase";
import { AllRoles } from "@/auth/roles";

const useAuthStateListener = () => {
  const dispatch = useDispatch();
  const handleResolve = (user) => {
    const roles = user.reloadUserInfo?.customAttributes ? JSON.parse(user.reloadUserInfo?.customAttributes)?.roles : [];
    const featuresUnlocked = roles.includes(AllRoles.webUserStandard) || roles.includes(AllRoles.webUserAdvanced);

    dispatch(
      setUser({
        ...user.toJSON(),
        roles,
        featuresUnlocked,
      }),
    );
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebase, (user) => {
      if (user) {
        fetch(`${window.cmai.config.apiURL}loggedIn`, {
          credentials: "include",
        }).then(async (response) => {
          if (response.ok) {
            handleResolve(user);
          } else {
            await fetch(`${window.cmai.config.apiURL}sessionLogin`, {
              method: "POST",
              body: JSON.stringify({
                idToken: user.toJSON().stsTokenManager.accessToken,
              }),
              headers: {
                "Content-Type": "application/json",
              },
              credentials: "include",
            }).then((res) => {
              if (res.ok) {
                handleResolve(user);
              } else {
                console.log("User not already logged in, so send him to login page");
                dispatch(logoutUser());
              }
            });
          }
        });
      } else {
        dispatch(clearUser());
      }
    });

    return () => unsubscribe();
  }, [dispatch]);
};

export default useAuthStateListener;
